import { toast } from "sonner";

// Scroll to the first visible match of `selector` and make it glow (used by the guides' "Show me").
// Polls briefly so it works right after navigating to another page.
export const glowTarget = (selector, { timeout = 3500, missing = "This part appears once it's set up." } = {}) => {
  const started = Date.now();
  // Comma-separated selectors are a priority list (querySelectorAll would return document order,
  // so an ancestor fallback like the page wrapper would always win).
  const parts = selector.split(",").map((s) => s.trim()).filter(Boolean);
  const visible = (el) => el.offsetHeight > 0 || el.offsetWidth > 0;
  const find = () => {
    for (const s of parts) {
      const el = Array.from(document.querySelectorAll(s)).find(visible);
      if (el) return el;
    }
    return null;
  };
  const tick = () => {
    const el = find();
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.classList.add("guide-glow");
      setTimeout(() => el.classList.remove("guide-glow"), 3600);
      return;
    }
    if (Date.now() - started < timeout) setTimeout(tick, 150);
    else if (missing) toast(missing);
  };
  setTimeout(tick, 150);
};
